import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import {
  ARBleAzoteFrequency,
  ARVerseApportMoAutomne,
  ARVerseApportsMinerauxFractionnement,
} from '../../../../models/agrorendement-ble-lists.model';
import { ARVerseSimpData } from '../../../../models/agrorendement-common.model';
import { ListItem } from '../../../../models/lists.model';
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe';
import { ARBleListsService, ARBleListType } from '../../../../services/agrorendement-ble-lists.service';
import { ModalService } from '../../../../services/modal.service';
import { Tooltip } from '../../../../utils/Tooltip';
import { TOOLTIP_TEXTS } from '../../../../utils/tooltip-texts';
import { TooltipContent } from '../../../../utils/TooltipContent';
import { isBooleanValue, showErrorMessage, sortingNumber, toBoolean } from '../../../../utils/utils';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  standalone: true,
  selector: 'ar-verse-simp-edit',
  templateUrl: 'verse-simp-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, Tooltip, TooltipContent, CapitalizePipe, TranslatePipe, TranslateWithPunctuationPipe, FormsModule, TooltipModule],
})
export class ARVerseSimpEditComponent implements OnInit, OnChanges {
  @Input() verseData: ARVerseSimpData;
  @Input() isBatch: boolean;
  @Input() cbBatchEdit: Object;
  error: any;

  areListsFetched = false;
  pastAzoteFrequencies: ARBleAzoteFrequency[];
  verseApportMoAutomnes: ARVerseApportMoAutomne[];
  verseApportsMinerauxFractionnements: ARVerseApportsMinerauxFractionnement[];

  requireVerseInfo: boolean = undefined;

  tooltipTexts: any;

  constructor(
    private bleListService: ARBleListsService,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.tooltipTexts = TOOLTIP_TEXTS;
  }

  getLists() {
    const listTypes = [
      ARBleListType.BLE_AZOTE_FREQUENCIES,
      ARBleListType.VERSE_APPORT_MO_AUTOMNE,
      ARBleListType.VERSE_APPORTS_MINERAUX_FRACTIONNEMENT,
    ];
    return this.bleListService.getListTypes(ARBleListType, ...listTypes);
  }

  handleLists(lists: Map<ARBleListType, ListItem[]>) {
    // TODO meileur facon de gerer ca ?
    this.areListsFetched = true;

    this.pastAzoteFrequencies = lists.get(ARBleListType.BLE_AZOTE_FREQUENCIES).sort(sortingNumber('id'));
    this.verseApportMoAutomnes = lists.get(ARBleListType.VERSE_APPORT_MO_AUTOMNE).sort(sortingNumber('id'));
    this.verseApportsMinerauxFractionnements = lists
      .get(ARBleListType.VERSE_APPORTS_MINERAUX_FRACTIONNEMENT)
      .sort(sortingNumber('id'));
  }

  ngOnInit() {
    const obs2 = this.getLists();
    obs2.subscribe(
      (data: Map<ARBleListType, ListItem[]>) => {
        // on suppose que le orderItem a ete
        this.handleLists(data);
        // au cas ou le orderItem ait ete sette avant
        if (this.verseData) {
          this.prepare();
        }
      },
      (e) => this.handleGetError(e),
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    const verseDataChange: SimpleChange = changes['verseData'];
    // au cas ou les listes ait ete recuperees avant
    if (verseDataChange !== undefined && verseDataChange.isFirstChange() && this.areListsFetched) {
      this.prepare();
    }
  }

  prepare() {
    if (!isBooleanValue(this.verseData.needsVerse)) {
      this.verseData.needsVerse = false;
    }
    this.onChangeNeedsVerse(this.verseData.needsVerse, true);
  }

  onChangeNeedsVerse(needsVerse: any, isInit = false) {
    needsVerse = toBoolean(needsVerse);
    this.verseData.needsVerse = needsVerse;
    this.requireVerseInfo = needsVerse;
    if (!needsVerse) {
      // TODO efface les donnees du calcul agrofert sauf celles necessaires au risque de verse ?!
      this.eraseVerseData();
      /*if(isInit) {
                this.prepareVerseData();
            }*/
    } else {
      this.prepareVerseData();
    }
  }

  eraseVerseData() {
    this.verseData.pastAzoteFrequency = new ARBleAzoteFrequency();
    this.verseData.pastAzoteFrequency.id = null;

    this.verseData.verseApportMoAutomne = new ARVerseApportMoAutomne();
    this.verseData.verseApportMoAutomne.id = null;

    this.verseData.verseApportsMinerauxFractionnement = new ARVerseApportsMinerauxFractionnement();
    this.verseData.verseApportsMinerauxFractionnement.id = null;
  }

  prepareVerseData() {
    if (!this.verseData.pastAzoteFrequency || !this.verseData.pastAzoteFrequency.id) {
      this.verseData.pastAzoteFrequency = new ARBleAzoteFrequency();
      this.verseData.pastAzoteFrequency.id = null;
      for (const p of this.pastAzoteFrequencies) {
        if (p.code == 'NONE') {
          this.verseData.pastAzoteFrequency.id = p.id;
          break;
        }
      }
    }

    if (!this.verseData.verseApportMoAutomne || !this.verseData.verseApportMoAutomne.id) {
      this.verseData.verseApportMoAutomne = new ARVerseApportMoAutomne();
      this.verseData.verseApportMoAutomne.id = null;
      for (const p of this.verseApportMoAutomnes) {
        if (p.code == 'NONE') {
          this.verseData.verseApportMoAutomne.id = p.id;
          break;
        }
      }
    }

    if (!this.verseData.verseApportsMinerauxFractionnement || !this.verseData.verseApportsMinerauxFractionnement.id) {
      this.verseData.verseApportsMinerauxFractionnement = new ARVerseApportsMinerauxFractionnement();
      this.verseData.verseApportsMinerauxFractionnement.id = null;
      for (const p of this.verseApportsMinerauxFractionnements) {
        if (p.code == '3') {
          this.verseData.verseApportsMinerauxFractionnement.id = p.id;
          break;
        }
      }
    }
  }

  handleGetError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'etes pas autorise a consulter cette parcelle").then((r) => {
        this.router.navigate(['/orders', 'azote', 'ble', 'parcels']);
      });
    } else {
      console.error(error);
      showErrorMessage(this.modal, 'Une erreur est survenue').then((r) => {
        this.router.navigate(['/orders', 'azote', 'ble', 'parcels']);
      });
    }
  }
}
